import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { Box, Grid, Typography } from "@material-ui/core";
import useStyles from "../CalloutCard/styles";
import CircleArrowButton from "../CircleArrowButton/CircleArrowButton";

export type CalloutCardProps = {
  loading?: boolean;
  midInfo?: JSX.Element;
  icon: JSX.Element;
  title: string;
  description: string;
  button: JSX.Element;
  arrowNavigationHref: string;
};

const CalloutCard = ({
  loading,
  midInfo,
  icon,
  title,
  description,
  button,
  arrowNavigationHref,
}: CalloutCardProps) => {
  const classes = useStyles();

  const gridInfo = (
    <Grid container spacing={6} justify="flex-start" alignItems="center">
      <Grid item>
        {React.cloneElement(icon, { className: classes.icon })}
      </Grid>
      <Grid item>
        <Box display="inline-flex" alignItems="center">
          <Typography component="span" className={classes.title}>
            {title}
          </Typography>
          <Box display="inline-flex" ml={2}>
            <CircleArrowButton
              to={arrowNavigationHref}
              viewTextAlign="right"
            />
          </Box>
        </Box>
        <Typography>{description}</Typography>
      </Grid>
    </Grid>
  );

  const skeleton = (
    <>
      <Grid item>
        <Skeleton width={840} height={120} />
      </Grid>
      <Grid item>
        <Skeleton width={212} height={120} />
      </Grid>
    </>
  );

  return (
    <Grid
      container
      justify="space-between"
      alignContent="center"
      direction="row"
      className={classes.grid}
    >
      {loading ? (
        skeleton
      ) : (
        <>
          <Grid item xs={6}>
            <Box height={"100%"}>{gridInfo}</Box>
          </Grid>
          <Grid
            item
            xs={3}
            container
            justify="flex-start"
            alignContent="center"
          >
            {midInfo}
          </Grid>
          <Grid
            item
            container
            xs={3}
            justify="center"
            alignContent="center"
            alignItems="center"
          >
            <Box height={40} display="flex">
              {button}
            </Box>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default CalloutCard;
